import React, { useContext, useEffect } from "react";

// Pretty print JSON package
import JSONPretty from "react-json-pretty";
import JSONPrettyTheme from "./JSONPrettyTheme.css";

//use history
import { useHistory } from "react-router-dom";

//fade in effect
import FadeIn from "react-fade-in";

// global state
import { StateContext } from "../../AppStateContext";

//styling
import "./style.scss";

const SchemaContent = ({ schema }) => {
  //consume global state
  const state = useContext(StateContext);

  //consume history
  const history = useHistory();

  useEffect(() => {
    history.push("/console/Schema/view-schema");
  }, [history]);

  return (
    <FadeIn transitionDuration={1000}>
      <div className="__SchemaContent">
        <h1
          className={
            state.theme === "dark"
              ? "__schemaContentHeaderDark"
              : "__schemaContentHeaderLight"
          }
        >
          **We will add the 'view schema' page in a later issue**
        </h1>
        <div className="__schemaJson">
          <JSONPretty
            id="json-pretty"
            data={schema}
            theme={JSONPrettyTheme}
          ></JSONPretty>
        </div>
      </div>
    </FadeIn>
  );
};

export default SchemaContent;
